"use client";
import Image from "next/image";
import { useState } from "react";
import Table from "./table";
import Game from "./game";
import TableWinner from "./table-winner";
import { ICampaign } from "@/interface";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

export default function LandingPage({ campaign }: { campaign: ICampaign }) {
  const [date, setDate] = useState<number>(Date.now());
  return (
    <div>
      {/* Carousel */}
      <section id="home" className="w-full relative" style={{ scrollMarginTop: "96px" }}>
        <Carousel
          plugins={[
            Autoplay({
              delay: 5000,
            }),
          ]}
          className="w-full"
        >
          <CarouselContent>
            {campaign?.landing_page_banner?.map((item: any, index: number) => (
              <CarouselItem key={index}>
                <div className="w-full relative aspect-[16/9] bg-gray-200">
                  <Image
                    src={item.url || ""}
                    alt={`banner-${index}`}
                    fill
                    className="object-cover"
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </section>

      {/* Rule */}
      <section id="rule">
        <div style={{ backgroundColor: campaign?.contest_rules_background_color }} className="min-h-screen flex items-center">
          <div className="container mx-auto px-3 sm:px-6 lg:px-8">
            <div className="py-34 flex flex-col gap-16">
              <div className="text-6xl font-bold text-white uppercase text-center" style={{ color: campaign?.contest_rules_title_color || "white" }}>
                {campaign?.contest_rules_title}
              </div>
              <div className="bg-white p-10 rounded-2xl shadow-lg max-h-[800px] lg:w-[1000px] mx-auto overflow-y-auto">
                <div className="ck-content contest-rules">
                  <div dangerouslySetInnerHTML={{ __html: campaign?.contest_rules }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Game campaign={campaign} setDate={setDate} />

      {/* List Participant */}
      <section id="join-list">
        <div>
          <div className="container mx-auto px-3 sm:px-6 lg:px-8">
            <div className="py-36 flex flex-col gap-10">
              <div className="text-5xl font-bold text-center">
                Danh sách khách hàng tham gia
              </div>
              <Table headerBackground="#C60E17" campaign={campaign} />
            </div>
          </div>
        </div>
      </section>

      {/* Winner */}
      <section id="winner-list">
        <div style={{ backgroundColor: "#A41115" }} className="relative">
          <img
            src="./background.png"
            alt="background"
            className="w-full h-full object-cover absolute top-0 left-0 z-1"
            style={{ objectPosition: "top" }}
          />
          <div className="container mx-auto px-3 sm:px-6 lg:px-8 z-2 relative">
            <div className="py-36 flex flex-col gap-10">
              <div className="text-5xl font-bold text-center text-white">
                Chúc mừng quý khách trúng thưởng
              </div>
              <TableWinner
                headerBackground="#FE343C"
                rounds={campaign?.rounds}
                campaign={campaign}
                date={date}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
